/**
 * CMCD `json` transmission mode.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_JSON = 'json';
